import { combineReducers } from "redux";
import accountTransactionsReducer from "./account_transactions_reducers";
import globalTransactionsReducer from "./global_transacctions_reducers";

const gatewayNameReducer = combineReducers({
    account: accountTransactionsReducer,
    global: globalTransactionsReducer
});

export default gatewayNameReducer;
